// Svelte 5 no longer needs svelte/store imports for basic reactivity

function loadTimingAndSyncSettingsFromLocalStorage() {
    let timingAndSyncSettings = JSON.parse(localStorage.getItem("cc-timing-and-sync-settings")) || {
        timingMode: "dual", //long or dual
        compensation: 0,
        startTimeOnly: false,
        shortcuts: {
            "showEvent": "Ctrl+ArrowUp",
            "hideEvent": "Ctrl+ArrowDown",
            "togglePanel": ""
        }
    }

    return timingAndSyncSettings;
}

// Create reactive state for timing and sync settings
export const timingAndSyncSettingsState = $state(loadTimingAndSyncSettingsFromLocalStorage());